import ChatMembership from 'entities/ChatMembership';
import Collection from 'lib/Collection';

class ChatMemberships extends Collection<ChatMembership> {
  initialize() {
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof ChatMembership' is missing the follow... Remove this comment to see the full error message
    this.model = ChatMembership;
  }
}

export default ChatMemberships;
